import '../../../styles/components/list/index.scss';

import { toggleDropdown, selectOption } from '../pagination';

const dropDown = document.querySelector('.label span');
const options = document.querySelectorAll('div#paginationOptions ul li');
const select = document.querySelectorAll('div.custom-select')[0];
const selectBox = document.getElementById('paginationOptions');
const dropDownArrow = document.getElementById('dropDownArrow');

function handleToggleDropdown() {
  toggleDropdown(selectBox, dropDownArrow);
}

function handleSelectOption() {
  selectOption(dropDown, selectBox, dropDownArrow, this.innerHTML);
}

if (options && options.length) {
  for (let i = 0; i < options.length; i++) {
    options[i].onclick = handleSelectOption;
  }
}

window.addEventListener('mouseup', event => {
  if (
    selectBox &&
    event.target !== select &&
    event.target.parentNode !== select &&
    event.target.parentNode.parentNode !== select
  ) {
    selectBox.setAttribute('class', 'hidden');
    dropDownArrow.style.transform = 'rotate(0deg)';
  }
});

if (select) {
  select.onclick = handleToggleDropdown;
}
